export const SLIDER_SKELETON = [{
  name: 'BaseSlider',
  type: 'div',
  isLoopParent: true,
  children: [
    { name: 'Slide', type: 'div' }
  ]
}]

